import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';

import { Maraton } from '../models/maraton';
import { MaratonService } from '../services/maraton.service';
@Component({
  selector: 'app-maraton',
  templateUrl: './maraton.component.html',
  styleUrls: ['./maraton.component.css']
})
export class MaratonComponent implements OnInit {


  model: Maraton = new Maraton();
  url = environment.imgUrl;

  constructor(private modelService: MaratonService, private route: ActivatedRoute) {
    this.model.id = Number(this.route.snapshot.paramMap.get('id'));
  }

  ngOnInit() {

    if (this.model.id == 0) {
      // this.modelService.getLast().subscribe(val => {
      //   this.model = val;
      // });

      let filter = {
        "destacado": 1
      }
      this.modelService.getFilter(filter).subscribe(val => {
        this.model = val[0];
      });


    }
    else {
      this.modelService.get(this.model.id).subscribe(val => {
        this.model = val;
      });
    }


  }

}
